/* eslint-disable wrap-iife */
(function($) {
  'use strict';

  var $courseAccordionItems = $('.course-accordion__item');

  if ($courseAccordionItems.length) {
    $('.course-accordion__item > .course-accordion__toggle').on(
      'click',
      function() {
        var $accordionToggle = $(this),
          $accordionText = $accordionToggle.siblings(
            '.course-accordion__content'
          );

        if ($accordionToggle.hasClass('active')) {
          $accordionToggle.removeClass('active');
          $accordionText.slideUp(300, function() {
            $accordionText.removeClass('active').removeAttr('style');
          });
        } else {
          $accordionToggle.addClass('active');
          $accordionText.slideDown(300, function() {
            $accordionText.addClass('active').removeAttr('style');
          });
        }

        return false;
      }
    );

    var $itemsWithIds = $courseAccordionItems.filter('[id]');

    if ($itemsWithIds.length) {
      $(window).on('hashchange', function() {
        var hash = window.location.hash.substring(1);
        var $targetItem = hash ? $itemsWithIds.filter('#' + hash) : [];
        if ($targetItem.length) {
          var $accordionToggle = $targetItem.find('.course-accordion__toggle'),
            $accordionText = $targetItem.find('.course-accordion__content');
          var stickyNavHeight = $('.inpage-nav').height() || 0;

          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $targetItem.offset().top - stickyNavHeight - 10,
            },
            200
          );
          $accordionToggle.addClass('active');
          $accordionText.slideDown(300, function() {
            $accordionText.addClass('active').removeAttr('style');
          });
        }
      });
    }
  }
})(jQuery);
